<!-- Company Logo Header -->
<header class="site-header" *ngIf="event && event.company?.image">
  <div class="page-wrapper">
    <img
      [src]="event!.company!.image"
      [alt]="event!.company!.name || 'Company Logo'"
      class="company-logo"
    />
  </div>
</header>

<!-- Main Content -->
<main>
  <ng-content></ng-content>
</main>

<!-- In-Content ISI Section -->
<section
  class="isi-inline"
  *ngIf="showIsi"
  #isiSection
>
  <div class="page-wrapper">
    <button class="isi-inline-header" (click)="toggleIsi()">
      <span class="isi-inline-title">Important Safety Information</span>
      <span class="isi-chevron" [class.expanded]="isiExpanded">
        <!-- Chevron SVG -->
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" fill="currentColor"/>
        </svg>
      </span>
    </button>
    <div class="isi-inline-body" *ngIf="isiExpanded">
      <div *ngIf="!hasRealIsi" class="isi-placeholder-notice">
        📋 Placeholder — no ISI content received from backend
      </div>
      <div [innerHTML]="isiContent"></div>
    </div>
  </div>
</section>

<!-- Sticky ISI Footer Bar -->
<div
  class="isi-sticky-bar"
  *ngIf="showIsi && showStickyIsiBar"
  (click)="scrollToIsi()"
>
  <div class="page-wrapper">
    <div class="isi-inline-header">
      <span class="isi-sticky-text">Important Safety Information</span>
      <span class="isi-sticky-chevron">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" fill="currentColor"/>
        </svg>
      </span>
    </div>
  </div>
</div>
